module.exports = __webpack_public_path__ + "static/media/about-img.c83dc045.jpg";